import { render, staticRenderFns } from "./Odds.vue?vue&type=template&id=a9767b40&scoped=true"
import script from "./Odds.vue?vue&type=script&lang=js"
export * from "./Odds.vue?vue&type=script&lang=js"
import style0 from "./Odds.vue?vue&type=style&index=0&id=a9767b40&prod&lang=scss"
import style1 from "./Odds.vue?vue&type=style&index=1&id=a9767b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9767b40",
  null
  
)

export default component.exports